import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import {
  BlogCategoryResponse,
  BlogContentListTypeResponse,
  ContentBlogDetailsResponse,
} from "api/blog/type";
import { ResponseEnum } from "enums/response";
import { NoInfer } from "react-redux";
import { BlogStateType } from "types/blog";

import {
  getContentBlogDetail,
  getListCategoryBlog,
  getListContentBlog,
} from "./blog.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<BlogStateType>>
) => {
  builder.addCase(
    getListCategoryBlog.fulfilled,
    (state: BlogStateType, action: PayloadAction<BlogCategoryResponse>) => {
      if (action.payload.status !== ResponseEnum.statusSuccess) return;

      state.dataBlogCategory = [...action.payload.data];
    }
  );
  builder
    .addCase(getListContentBlog.pending, (state: BlogStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getListContentBlog.fulfilled,
      (
        state: BlogStateType,
        action: PayloadAction<BlogContentListTypeResponse>
      ) => {
        state.isLoading = false;
        if (action.payload.status !== ResponseEnum.statusSuccess) return;

        state.dataBlogContentList = { ...action.payload };
      }
    );
  builder
    .addCase(getContentBlogDetail.pending, (state: BlogStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getContentBlogDetail.fulfilled,
      (
        state: BlogStateType,
        action: PayloadAction<ContentBlogDetailsResponse>
      ) => {
        state.isLoading = false;
        if (action.payload.status !== ResponseEnum.statusSuccess) return;
        state.dataContentBlogDetail = { ...action.payload.data };
      }
    );
};
